import { useMutation, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import { useModals } from "ModalProvider";
import ChooseImagesFromOneDriveView from "./ChooseImagesFromOneDriveView";
import {
  FETCH_PRODUCT_IMAGES,
  SAVE_PRODUCT_IMAGE_SETTINGS,
  SYNC_PRODUCT_WIS_IMAGES,
} from "./graphql";

const ProductImagesView = ({ id }) => {
  const { loading, error, data } = useQuery(FETCH_PRODUCT_IMAGES, {
    variables: { id },
  });
  const [syncProductImagesFromOneDrive, syncProductImagesFromOneDriveRes] =
    useMutation(SYNC_PRODUCT_WIS_IMAGES, {
      onCompleted() {
        Alert("success", "Images synced.");
      },
      onError(error) {
        Alert("error", error.message);
      },
    });

  const [saveImageSettings, saveImageSettingsRes] = useMutation(
    SAVE_PRODUCT_IMAGE_SETTINGS,
    {
      onCompleted() {
        Alert("success", "Settings saved.");
      },
    },
  );

  const modal = useModals();

  function chooseImages() {
    modal.present({
      title: "Choose Images",
      subtitle: "From One Drive",
      fullscreen: true,
      children: <ChooseImagesFromOneDriveView onSave={saveImages} />,
    });
  }

  function saveImages(selectedImages) {
    modal.hide();
    syncProductImagesFromOneDrive({
      variables: {
        productId: id,
        ids: selectedImages.map((i) => i.id),
      },
    });
  }

  if (loading) return <InlineSpinner text={null} size={21} />;
  if (error) return <Errors error={error} />;

  return (
    <div>
      {data.product.images.length === 0 ? (
        <div className="mb-2 opacity-70">
          This product does not have any images.
        </div>
      ) : (
        <div className="flex flex-wrap">
          {data.product.images.map((i) => (
            <img className="mr-2 mb-2 w-20" key={i.id} src={i.url} />
          ))}
        </div>
      )}

      <div>
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              className="mr-1"
              checked={data.product.useProductLineImagesIfNoImages}
              onChange={(e) =>
                saveImageSettings({
                  variables: {
                    id,
                    simpleFields: {
                      useProductLineImagesIfNoImages: e.target.checked,
                    },
                  },
                })
              }
              disabled={saveImageSettingsRes.loading}
            />
            Use product line images if no images
          </label>
        </div>

        <Button
          className="mt-2"
          onClick={chooseImages}
          loading={syncProductImagesFromOneDriveRes.loading}
        >
          Choose Images from One Drive
        </Button>
      </div>
    </div>
  );
};

export default ProductImagesView;
